import { Dialog, Divider, IDialogProps, Justify, Size } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ReactNode } from 'react';
import HeaderDialogHeader from '../HeaderDialogHeader/HeaderDialogHeader';

export interface IHeaderDialogProps extends IDialogProps {
  title: string;
  subtitle?: string;
  headerSize?: Size;
  showBackArrowAsClose?: boolean;
  rightContent?: ReactNode;
  headerClass?: string;
  divider?: boolean;
  marginRightContent?: boolean;
}

const HeaderDialog = ({
  children,
  className,
  title,
  subtitle,
  headerSize = Size.LARGE,
  headerClass,
  divider,
  marginRightContent,
  showBackArrowAsClose = false,
  rightContent,
  onClose,
  hasDismiss = true,
  ...dialogProps
}: IHeaderDialogProps) => {
  function getDividerStatus() {
    return divider === undefined || divider === true;
  }

  const showBackArrow = !!showBackArrowAsClose && !!hasDismiss;

  const classes = classNames('header-dialog', className);

  return (
    <Dialog className={classes} {...dialogProps} onClose={onClose} hasDismiss={!showBackArrowAsClose && hasDismiss}>
      <HeaderDialogHeader
        title={title}
        subtitle={subtitle}
        showBackArrow={showBackArrow}
        rightContent={
          marginRightContent == false ? (
            rightContent
          ) : rightContent ? (
            <div className="mr-6">{rightContent}</div>
          ) : undefined
        }
        onClose={onClose}
        justify={Justify.SPACE_BETWEEN}
        className={headerClass}
        size={headerSize}
      />
      {getDividerStatus() && <Divider />}
      {children}
    </Dialog>
  );
};

export default HeaderDialog;
